// extracted by mini-css-extract-plugin
export default {"permissioncontainer":"Chatpermission_permissioncontainer__pW+d6","permissionnav":"Chatpermission_permissionnav__PRDhf","permissions":"Chatpermission_permissions__sQQqf"};